import { render } from "./RatingStars.vue?vue&type=template&id=2f6ceae8&scoped=true"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"

import "./RatingStars.vue?vue&type=style&index=0&id=2f6ceae8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6ceae8"]])

export default __exports__